import React from 'react'
import styled from 'styled-components'
import {WINDOW_MODE_TABLET_WIDTH} from 'consts'
import convertUnit from 'lib/unit'
import GiftShopUploadDropzoneBulk from './GiftShopUploadDropzoneBulk'
import {GiftShopUploadDropzoneProps} from './GiftShopUploadDropzoneProps'
import GiftShopUploadDropzoneVideo from './GiftShopUploadDropzoneVideo'

const StyledContainer = styled.div`
  padding: ${convertUnit(20)};
  display: flex;
  flex-direction: row;
  height: 100vh;
  gap: ${convertUnit(20)};
  @media (max-width: ${WINDOW_MODE_TABLET_WIDTH}px) {
    flex-direction: column;
  }
`

const StyledUploadPhotoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${convertUnit(20)};
  flex: 1;
`

const StyledUploadVideoContainer = styled.div`
  display: flex;
  flex: 1;
`

export default function GiftShopUploadDropzone({
  onUploadBulk,
  validator,
  videoValidator,
  onUploadVideo,
  onClickBulk,
  onClickVideo,
  onNonVerifiedCreatorUpload,
}: GiftShopUploadDropzoneProps) {
  return (
    <StyledContainer>
      <StyledUploadPhotoContainer>
        <GiftShopUploadDropzoneBulk
          onUploadBulk={onUploadBulk}
          validator={validator}
          onClickBulk={onClickBulk}
        />
      </StyledUploadPhotoContainer>
      <StyledUploadVideoContainer>
        <GiftShopUploadDropzoneVideo
          onUploadVideo={onUploadVideo}
          videoValidator={videoValidator}
          onClickVideo={onClickVideo}
          onNonVerifiedCreatorUpload={onNonVerifiedCreatorUpload}
        />
      </StyledUploadVideoContainer>
    </StyledContainer>
  )
}
